<template>

  <modal name="createTaskModal" @closed="hideModal" tabindex="-1" aria-hidden="true" width="700" height="auto">
    <div class="row p-4">
      <div class="col-md-12">
        <button @click="hideModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
        <!--              <label class="mb-1 mt-4"><i class="fe fe-check-circle mr-2"></i>New task name </label>-->
        <textarea
          @keyup.enter="createTask()"
          v-model="name" ref="createTaskInput"
          spellcheck="false"
          @input="adjustTextArea()"
          :placeholder="$t('modals.create_task_modal.set_task_purpose')" rows="1"
          class="form-control form-control-flush"
          style="font-size: 1.5rem; resize: none; text-shadow: 0 0.5px gainsboro;"
        />

        <!--              <input @keyup.enter="createTask" ref="createTaskInput" spellcheck="false" placeholder="Set task purpose" class="form-control form-control-flush form-control-sm" style="font-size: 1.4rem; resize: none; text-shadow: 0 0.5px gainsboro;" v-model="name">-->
        <div class="row mt-4">
          <div class="col-4">
            <project-select :create_task_modal="true" class=""></project-select>
          </div>
          <div class="col-6">
            <div class="">
              <duration-picker :is_for_project="false" :task_mode="false"></duration-picker>
            </div>
          </div>
          <div class="col-2">
            <div class="">
              <button @click="createTask" type="button" class="btn btn-sm btn-primary float-right "><i
                class="fe fe-check-circle mr-2"></i>{{ $t('modals.create_task_modal.create') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </modal>
</template>

<script>
  import ProjectSelect from '../components/elements/ProjectSelect';
  import { mapGetters } from 'vuex';
  import DurationPicker from '../components/elements/DurationPicker';

  export default {
    name: 'create_task',
    data () {
      return {
        drag: false,
        name: '',
        unique_id: null,
      };
    },

    computed: {
      ...mapGetters([
        'window',
        'task_template',
        'show_modal_create_task',
        'selected_project_id',
        'selected_duration',
      ]),
    },
    watch: {
      show_modal_create_task: function () {
        if (this.show_modal_create_task === true) {
          if (this.task_template.name) {
            this.name = this.task_template.name;
            this.$store.commit('setSelectedDuration', this.task_template.duration);
            this.$store.commit('setSelectedProjectId', this.task_template.project_id);
          }
          this.$modal.show('createTaskModal');
          setTimeout(() => this.adjustTextArea(), 600);
          setTimeout(() => this.$refs.createTaskInput.focus(), 850);
        }
      },

    },

    methods: {
      getMember (memberId) {
        return this.members.find(m => m._id === memberId, 1) || {};
      },
      createTask () {
        if (this.name.trim().length) {
          this.task_template.name = this.name;

          this.task_template.duration = this.selected_duration;
          this.$store.dispatch('createTask', this.task_template);

          this.name = '';
          this.task_template.name = '';
        } else {
          this.$noty.error('Error: Empty Task Name');
        }

        setTimeout(() => {
          this.$modal.hide('createTaskModal');
        }, 0);
        setTimeout(() => {
          const path = this.$route.path.match(/^\/[A-Za-z0-9]+/)[0];
          if (path !== '/calendar') {
            this.$modal.show('editTaskModal');
          }
          this.$store.commit('setSelectedDuration', 60);
        }, 1000);
      },
      adjustTextArea () {
        if (this.$refs.createTaskInput) {
          this.$refs.createTaskInput.style.height = 0;
          this.$refs.createTaskInput.style.height = Math.min(this.$refs.createTaskInput.scrollHeight, window.innerHeight - 250) + 'px';
        }
      },
      hideModal () {
        this.$store.commit('hideModal', 'create_task');
        this.$modal.hide('createTaskModal');
      },
    },
    created: function () {
      this.unique_id = Math.random().toString();
      setTimeout(() => this.adjustTextArea(), 800);
    },
    components: {
      ProjectSelect,
      DurationPicker,
    },

  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  html, body {
    width: 100%;
    height: 100%;
  }

</style>
